<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Change Payment Password') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Update your secure payment credentials, ensuring your account remains protected during transaction') }}</span>
            </div>

            <step-container
                :current_step="3"
                :step_list="stepList"
            ></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <div id="body-container" class="py-5">
                <b-row>
                    <b-col cols="12" xl="7" class="p-5 ml-auto">
                        <h4>{{ $t("Change Password") }}</h4>
                        <div class="fz-14 fw-700 pt-4 mb-3">{{ $t("Repeat Payment Password") }}</div>
                        <div class="d-flex mb-4 pr-5">
                            <input type="text" class="form-control mr-3 fz-24 fw-500 text-center" v-for="index in 6" maxlength="1" @input="onInput" v-on:keydown="onKeyDown" v-model="pin[index-1]">
                        </div>
                        <div class="text-danger">{{ $t(error.password) }}</div>
                    </b-col>
                    <b-col cols="12" xl="5" class="px-5">
                        <img :src="`${publicPath}img/gep/payment-password.svg`" class="w-100"/>
                    </b-col>
                </b-row>
                <b-row class="mt-5">
                    <b-col cols="12" class="d-flex">
                        <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                        <button @click="nextStep" class="btn btn-primary d-block mx-5">{{ $t('Submit') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import Common from "@/services/Common";

    export default {
        name: 'change-payment-password',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                stepList:["Old Payment Password","New Payment Password", "Repeat Password"],
                data:{},
                pin:['','','','','',''],
                show_password:false,
                password:'',
                error:{
                    password:''
                }
            }
        },
        components: {
            LoaderComponent,
            stepContainer
        },
        methods:{
            toggleShow(name) {
                this["show_"+name] = !this["show_"+name];
            },
            onChange(name){
                this.error[name]="";
            },
            onKeyDown(e){
                if(e.keyCode==8 && !e.target.value && e.target.previousSibling){
                    this.error.password = '';
                    e.target.previousSibling.focus();
                }
            },
            onInput(e){
                if(e.target && e.data && e.target.nextSibling){
                    e.target.nextSibling.focus();
                }
            },
            getMessage: function (key) {
            return this.$t(key)
            },
            nextStep(){
                const join = this.pin.join("");
               if(join==''){
                this.error.password = 'can not be blank.';
               }
               else if(join.length!=6){
                this.error.password = 'should be 6 digit.';
               }
               else if(join!=this.data.newpin){
                this.error.password = 'repeat password not same.';
               }
               else{
                this.isLoading = true;
                Common.change_payment_password({
                    "old_securitycode":this.data.oldpin,
                    "new_securitycode":this.data.newpin,
                    "new_re_securitycode":join
                }).then(response=>{
                    if(response.status==200){
                        this.isLoading = false;
                        this.$swal({
                            icon: 'success',
                            title: this.getMessage('Success'),
                            showConfirmButton: true,
                        }).then((result) => {
                            window.location.href = location.protocol+"//"+window.location.hostname;
                        });
                    }
                    }).catch(err => {
                        this.isLoading = false;
                        this.checkError(err);
                });
               }
            },
            checkError(err){
                this.isLoading = false;
                const response = err.response;  
                console.log("===================");
                let self = this;
                if(response.status == 400){
                    console.log(response.data);
                    if(typeof response.data.message === 'string'){
                        this.$swal({
                            icon: 'info',
                            html:response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else{
                        if(response.data.message['errorMsg']){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message['errorMsg'],
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            let ret = [];
                            Object.keys(response.data.message).forEach((key) => {
                                ret.push(response.data.message[key][0]);
                            });

                            this.$swal({
                                icon: 'info',
                                html:ret.join("<br>"),
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            }
        },
        mounted(){
            this.data = this.$route.params.data;
            if(!this.data){
                this.$router.push({ name: 'change-payment-password'});
            }
        }
    };
  </script>

<style scoped>
ul li{
    list-style: disc;
}
.point .number{
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}
.account-type:hover{
    background: linear-gradient(90deg, #00AEEF 0%, #0972D3 100%) !important;
}
.block-item{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
</style>